module.exports = __webpack_public_path__ + "media/styles/images/png/inline-arrow-down-gray-light-bccc70655a6cb4865d1030bb58a5b278.png";